import { Get, Post, Put, getAPIUrl } from "../../../services/apiMethod";

export const EnquiryEndpoint = {
  getEnquiryData: `/admin/get-enquiry`,
  getExportData: `/admin/get-enquiry-excel`,
};
export const getEnquiryData = (param = "") => {
  const url = getAPIUrl(EnquiryEndpoint.getEnquiryData, param);
  return Get(url);
};
export const getExportData = (param = "") => {
  const url = getAPIUrl(EnquiryEndpoint.getExportData, param);
  return Get(url);
};
